module.exports = __webpack_public_path__ + "img/zhengshu3-hui.39fef62a.png";